var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"vue-bigdata-table-input",domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }